import translations from '../../../../../translations';
import type { ComposerElement } from '../../../../../types/pageEditor';

type Props = Pick<ComposerElement, 'label' | 'attributes'>;

const Hyperlink = ({ label, attributes }: Props) => {
    const src = attributes?.['$src'];

    const linkText =
        label ||
        (typeof src === 'string' && src.length > 0
            ? src
            : typeof src !== 'string' && src?.id
              ? translations.PAGE_BUILDER_hyperlink_url_bound_to_value_link_text
              : translations.PAGE_BUILDER_hyperlink_no_url_provided_link_text);

    return (
        <a
            className="component-preview-hyperlink"
            data-testid="component-preview-hyperlink"
            aria-disabled
            href="https://boomi.com"
            rel="noreferrer"
            target="_blank"
        >
            {linkText}
        </a>
    );
};

export default Hyperlink;
